import SpriteSymbol from "../../../../../../../sfra-webpack-builder/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../sfra-webpack-builder/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "spinner_34px",
  "use": "spinner_34px-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid\" id=\"spinner_34px\"><circle cx=\"50\" cy=\"50\" fill=\"none\" stroke=\"#323232\" stroke-width=\"8\" r=\"39\" stroke-dasharray=\"183.7831702350029 63.261056745000964\"><animateTransform attributeName=\"transform\" type=\"rotate\" repeatCount=\"indefinite\" dur=\"1s\" values=\"0 50 50;360 50 50\" keyTimes=\"0;1\" /></circle></symbol>"
});
var result = sprite.add(symbol);
export default symbol